<template>
  <van-popup :close-on-click-overlay="false" v-model="show.flag" round position="bottom"
    :style="{ height: '30%', background: 'rgba(245, 244, 244, 1)', 'border-top-left-radius': '8px', 'border-top-right-radius': '8px', ...show.style}"
    transition-appea>
    <div :class="['position', show.flag ? '': 'none']" v-if="flag">
      <div class="top">
        <div class="close huisuiyunfont" @click="close">{{'\ue8fe'}}</div>
        <div class="center">
          {{show.selectTitle}}
        </div>
        <div class="right" @click="recovery">
          重置
        </div>
      </div>
    </div>
    <div class="content">
      <PopupContent v-if="show.type === 'month'" :tableList="monthTableList" :click="handleClick"></PopupContent>
      <PopupContent v-else-if="show.type === 'invoiceType'" :tableList="invoTypeTable" :click="handleClick"></PopupContent>
      <PopupContent v-else :tableList="show.tableList" :click="handleClick"></PopupContent>
      <slot></slot>
    </div>
  </van-popup>
</template>
<script>
import { Popup } from 'vant'
import moment from 'moment'
import PopupContent from '@/components/PopupContent'
export default {
  components: {
    [Popup.name]: Popup,
    PopupContent
  },
  watch: {
    'show.flag' (v) {
      console.log(v)
      setTimeout(() => {
        this.flag = v
      }, 500)
    }
  },
  props: {
    show: {
      type: Object,
      default: () => {}
    },
    title: {
      type: [String, Number],
      default: '请选择'
    },
    type: {
      type: String,
      default: ''
    },
    callBack: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      flag: false,
      year: moment().format('YYYY'),
      month: moment().format('MM'),
      monthTableList: [
        {
          header: Number(moment().format('YYYY')) - 1,
          children: [
            {
              id: Number(moment().format('YYYY')) - 1,
              title: '1月',
              index: 1
            }, {
              id: Number(moment().format('YYYY')) - 1,
              title: '2月',
              index: 2
            }, {
              id: Number(moment().format('YYYY')) - 1,
              title: '3月',
              index: 3
            }, {
              id: Number(moment().format('YYYY')) - 1,
              title: '4月',
              index: 4
            }, {
              id: Number(moment().format('YYYY')) - 1,
              title: '5月',
              index: 5
            }, {
              id: Number(moment().format('YYYY')) - 1,
              title: '6月',
              index: 6
            }, {
              id: Number(moment().format('YYYY')) - 1,
              title: '7月',
              index: 7
            }, {
              id: Number(moment().format('YYYY')) - 1,
              title: '8月',
              index: 8
            }, {
              id: Number(moment().format('YYYY')) - 1,
              title: '9月',
              index: 9
            }, {
              id: Number(moment().format('YYYY')) - 1,
              title: '10月',
              index: 10
            }, {
              id: Number(moment().format('YYYY')) - 1,
              title: '11月',
              index: 11
            }, {
              id: Number(moment().format('YYYY')) - 1,
              title: '12月',
              index: 12
            }
          ]
        },
        {
          header: moment().format('YYYY'),
          end: moment().format('MM')
        }
      ],
      invoTypeTable: [
        {
          header: '增值',
          left: true,
          children: [
            {
              id: '01',
              title: '专票',
              index: '01'
            },
            {
              id: '04',
              title: '普票',
              index: '04'
            },
            {
              id: '10',
              title: '电票',
              index: '10'
            },
            {
              id: '08',
              title: '电专',
              index: '08'
            },
            {
              id: '11',
              title: '卷票',
              index: '11'
            },
            {
              id: '09',
              title: '数电专',
              index: '09'
            },
            {
              id: '90',
              title: '数电普',
              index: '90'
            },
            {
              id: '85',
              title: '数电纸专',
              index: '85'
            },
            {
              id: '86',
              title: '数电纸普',
              index: '86'
            }
          ]
        },
        {
          header: '非增',
          left: true,
          children: [
            {
              id: '201',
              title: '火车',
              index: '201'
            },
            {
              id: '202',
              title: '飞机',
              index: '202'
            },
            {
              id: '207',
              title: '出租',
              index: '207'
            },
            {
              id: '200',
              title: '定额',
              index: '200'
            }
          ]
        }
      ]
    }
  },
  methods: {
    recovery () {
      this.callBack('recovery')
    },
    close (item) {
      let obj = { ...this.show }
      obj.flag = false
      this.$emit('update:show', obj)
    },
    handleClick (item) {
      this.callBack(item)
    }
  }
}
</script>
<style scoped lang="less">
.none{
  opacity: 0;
}
.position{
  top: 50%;
  position: fixed;
  width: 100%;
  height: 112px;
  background: rgba(245, 244, 244, 1);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}
.top{
  height: 100%;
  align-items: center;
  display: flex;
  position: relative;
  .close{
    width: 40px;
    margin-top: 12px;
    height: 40px;
  }
  .center{
    flex-grow: 1;
    text-align: center;
    font-size: 30px;
    color: rgba(31, 36, 51, 1);
    font-weight: bold;
  }
  .right{
    position: absolute;
    right: 16px;
    color: rgba(51, 120, 255, 1);
    font-size: 30px;
  }
  border-bottom: 1Px solid rgba(227, 228, 230, 1);
}
.close{
  position: absolute;
  top: 20px;
  left: 28px;
}
.content{
  padding: 8px 28px 0px;
  font-size: 30px;
  box-sizing: border-box;
  margin-top: 112px;
}
</style>
